import React from 'react';
import { Collapse } from 'antd';
import classNames from 'classnames';
import { ArrowDownIcon } from 'icons';

import { ILesson, IModule } from 'modules/courses';

interface IProps {
  modules?: IModule[];
  children: (children: ILesson) => React.ReactNode;
  isDrawer?: boolean;
}

const { Panel } = Collapse;

export const ModuleLesson = ({ modules, children, isDrawer = false }: IProps) => (
  <Collapse
    defaultActiveKey={modules?.[0]?.id}
    expandIconPosition="end"
    expandIcon={({ isActive }) => (
      <ArrowDownIcon
        className="mr-5 h-5 w-5 text-gray-100 transition-transform duration-300"
        style={{ transform: `rotate(${!isActive ? '180deg' : '0deg'})` }}
      />
    )}
    className="!rounded-xl !bg-transparent"
    bordered={false}
  >
    {modules?.map((module, index) => (
      <Panel
        key={module.id}
        header={
          <div className="flex flex-col gap-1 p-5">
            <div className="text-lg font-semibold text-gray-800">
              {index + 1}. {module.name}
            </div>
            {module.description && <div className="text-sm text-gray-500">{module.description}</div>}
          </div>
        }
        className={classNames(
          '!my-5 overflow-hidden !rounded-xl [&_.ant-collapse-header]:!mb-0 [&_.ant-collapse-header]:!flex [&_.ant-collapse-header]:!items-center',
          {
            '!bg-white': !isDrawer,
            '!border !border-gray-200 !bg-gray-50': isDrawer
          }
        )}
      >
        <div className="mb-4 border-b border-gray-100" />

        <div className="flex flex-col gap-4 px-2 pb-4">
          {module?.lessons?.map(lesson =>
            children({
              ...lesson
            })
          )}
        </div>
      </Panel>
    ))}
  </Collapse>
);
